
export default {

    walletBalance(state,data){
        state.walletBalance = data
    }
}